// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.postalCodeCorrectionInfo[data-v-0654c38a] {\n  height: 100%;\n}\n.addFormBox[data-v-0654c38a] {\n  height: calc(100% - 61px);\n  padding: 15px;\n  overflow-y: auto;\n}\n.addFooter[data-v-0654c38a] {\n  border-top: 1px solid #ccc;\n  padding: 10px;\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
